import { GenericTableRow } from '@features/reports/utils/buildTableData'
import { BALANCE_COLUMNS } from '@features/reports/views/NL/trialBalanceReport/constants/balanceColumns'
import { TrialBalanceTableBalance } from '@features/reports/views/NL/trialBalanceReport/types/tableTypes'
import { getBalanceByType } from '@features/reports/views/NL/trialBalanceReport/utils/getBalanceByType'

import { ReportsPdfTableBalanceCell } from '../ReportsPdfTableBalanceCell'

interface TrialBalanceBalanceCellProps {
  row: GenericTableRow<TrialBalanceTableBalance>
}

export const TrialBalanceBalanceCell = ({ row }: TrialBalanceBalanceCellProps) =>
  BALANCE_COLUMNS.map((activeColumn) => {
    const balance = getBalanceByType(row.balances, activeColumn.key) || 0

    return (
      <ReportsPdfTableBalanceCell
        key={activeColumn.key}
        balance={balance}
        columnKey={activeColumn.key}
        rowType={row.type}
      />
    )
  })
